// extracted by mini-css-extract-plugin
export default {"bannerContainer":"_MyuoLOxAuoVRdHZmari"};